import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from '@/components/button';

type Props = {
  className?: string;
  icon: ReactNode;
  selected?: boolean;
  onClick: () => void;
};

const OrientationOption: React.FC<Props> = ({
  className = '',
  icon,
  selected = false,
  onClick,
}: Props) => {
  return (
    <Button
      className={twMerge(
        'flex h-[56px] w-[56px] cursor-pointer flex-col items-center justify-center border-1 bg-gray-10 hover:bg-gray-20',
        selected ? 'border-green-utility' : 'border-gray-10',
        className
      )}
      onClick={onClick}
    >
      <div className={twMerge(selected ? 'opacity-100' : 'opacity-25')}>
        {icon}
      </div>
    </Button>
  );
};

export default OrientationOption;
